import Limbo from 'page/Limbo';
import React from 'react';
import Server from 'data/Server';
import { Redirect } from 'react-router';


const _wrap = cls => class extends cls {
  constructor() {
    super();
    this.server = new Server.Factory().create();
  }

  requiresAuth() {
    return true;
  };

  render() {
    let pathname = window.location.pathname;
    let search = window.location.search;

    if (this.server.isInitialDataLoaded() && this.server.user_email()) {
      return super.render(...arguments);
    }
    const to = pathname + search;
    return <Redirect to={Limbo.wrap(to)} />;
  }
}


const authProtect = cls => {
  if (cls.WrappedComponent) {
    cls.WrappedComponent = _wrap(cls.WrappedComponent);
    return cls;
  }

  return _wrap(cls);
};


export default authProtect;
